import { connect } from 'dva';

export default connect(
  ({ errors }) => ({
    formErrors: errors.formErrors,
  }),
);
